import { FC } from 'react';
import s from '#components/teaser-details/TeaserDetailsMeta.module.scss';
import useTranslation from 'next-translate/useTranslation';
import { getTranslatedMediaDuration } from '#utils/getMediaDuration';
import { useSpring, animated } from '@react-spring/web';

type Props = {
  duration?: number;
  year?: number;
  fskRating?: string;
  categories?: { title: string }[];
};

const TeaserDetailsMeta: FC<Props> = ({
  categories,
  duration,
  year,
  fskRating,
}) => {
  const { t } = useTranslation();
  const animation = useSpring({ to: { opacity: 1 }, from: { opacity: 0 } });

  return (
    <animated.div style={animation}>
      <ul className={s.host}>
        {!!fskRating && (
          <li className={`${s.item} ${s.isBoxOutline} ${s.hasNoDot}`}>
            <span className={s.itemInner}>
              {t('age')} {fskRating}
            </span>
          </li>
        )}

        {year > 0 && (
          <li className={s.item}>
            <span className={s.itemInner}>{year}</span>
          </li>
        )}
        {duration > 0 && (
          <li className={s.item}>
            <span className={s.itemInner}>
              {getTranslatedMediaDuration(duration, t)}
            </span>
          </li>
        )}
        {categories?.length > 0 && (
          <li className={s.item}>
            {categories.map((item, index) => (
              <span className={`${s.itemInner} ${s.hasDivider}`} key={index}>
                {item.title}
              </span>
            ))}
          </li>
        )}
      </ul>
    </animated.div>
  );
};

export default TeaserDetailsMeta;
